var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpriceRegisteredGateway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 79.998 71.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.913,
    y1: 0.758,
    x2: 0.097,
    y2: 0.181,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1487ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78bc27"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25377",
    "data-name": "Group 25377",
    transform: "translate(-806 -523)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3860",
    "data-name": "Ellipse 3860",
    cx: 34.804,
    cy: 34.804,
    r: 34.804,
    transform: "translate(816.389 524.883)",
    fill: "#e7eff9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3859",
    "data-name": "Ellipse 3859",
    d: "M24.867,2.331a25.032,25.032,0,0,0-8.858,1.591A22.828,22.828,0,0,0,8.834,8.228a19.8,19.8,0,0,0-4.774,6.3,17.661,17.661,0,0,0,0,15.241,19.8,19.8,0,0,0,4.774,6.3,22.829,22.829,0,0,0,7.176,4.306,25.455,25.455,0,0,0,17.715,0A22.829,22.829,0,0,0,40.9,36.067a19.8,19.8,0,0,0,4.774-6.3,17.661,17.661,0,0,0,0-15.241,19.8,19.8,0,0,0-4.774-6.3,22.828,22.828,0,0,0-7.176-4.306,25.032,25.032,0,0,0-8.858-1.591m0-2.331C38.6,0,49.734,9.916,49.734,22.147S38.6,44.294,24.867,44.294,0,34.379,0,22.147,11.133,0,24.867,0Z",
    transform: "translate(816.879 529.994)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3858",
    "data-name": "Ellipse 3858",
    d: "M36.135,2.331a38.226,38.226,0,0,0-13.259,2.33,34.4,34.4,0,0,0-10.761,6.315A29.2,29.2,0,0,0,4.937,20.24a25.513,25.513,0,0,0,0,22.464,29.2,29.2,0,0,0,7.178,9.264,34.4,34.4,0,0,0,10.761,6.315,38.9,38.9,0,0,0,26.519,0,34.4,34.4,0,0,0,10.761-6.315A29.2,29.2,0,0,0,67.333,42.7a25.513,25.513,0,0,0,0-22.464,29.2,29.2,0,0,0-7.178-9.264A34.4,34.4,0,0,0,49.394,4.661a38.226,38.226,0,0,0-13.259-2.33m0-2.331C56.091,0,72.269,14.091,72.269,31.472S56.091,62.944,36.135,62.944,0,48.854,0,31.472,16.178,0,36.135,0Z",
    transform: "translate(806 523)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpriceRegisteredGateway);
export default __webpack_public_path__ + "static/media/eprice_registered_gateway.c27919192ce906a981c4fd064caaa26f.svg";
export { ForwardRef as ReactComponent };